export default __webpack_public_path__ + "static/ogrodzenia-6ec062931e55af9f2908503bc681f07c.jpg";